/**
 * Spec 007 + 009 — donation presets + bounds shared by the donate form. Presets are common giving amounts
 * (EUR cents), NOT tiers — every amount confers the same (nothing but thanks, §7). The max mirrors the
 * finance minor-unit ceiling (€1 000 000). Kept in one module so the form and its tests agree on the numbers.
 */
export const PRESETS_ORE = [500, 1000, 1500, 2500, 5000] as const; // €5 / €10 / €15 / €25 / €50

/** Per-donation ceiling in minor units (€1 000 000) — matches the backend finance bound. */
export const MAX_ORE = 100_000_000;

export const AMOUNT_LABEL = 'Choose an amount';
